"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'modal.share.title': '分享内容',
};
